<template>
    <b-container fluid>

        <b-row>
            <b-col lg="3">
            </b-col>
            <b-col lg="6" style="text-align: left; padding-bottom: 20px;">
                <b-alert show variant="info" class="mt20">
                    <div v-html="promptMsg"></div>
                </b-alert>
            </b-col>
            <b-col lg="3">
            </b-col>
        </b-row>

        <b-row style="margin-top: 10px;" v-if="isSubmited && !expired">
            <b-col lg="12">
                <b-alert variant="success" show>您已经成功提交表单</b-alert>
            </b-col>
        </b-row>
        <b-row>
            <b-col lg="3">
            </b-col>
            <b-col lg="6" style="text-align: left; padding-bottom: 20px;">
                <h4 style="text-align: center; margin-top: 20px; font-weight: bold;">首科招募令</h4>
            </b-col>
            <b-col lg="3">
            </b-col>
        </b-row>

        <b-row v-if="expired">
            <b-col lg="3">
            </b-col>
            <b-col lg="6" style="text-align: left; padding-bottom: 20px;">
                <h4 style="text-align: center; margin-top: 20px; font-weight: bold;">招募令尚未开放，敬请关注网站消息</h4>
            </b-col>
            <b-col lg="3">
            </b-col>
        </b-row>

        <div class="container" v-if="!expired">
            <b-form @submit.stop.prevent="onSubmit">
                <b-form-group label="姓名:" label-align-lg="right" label-cols-lg="3" content-cols-lg="7" label-for="name">
                    <b-form-input id="name" v-model="form.name" v-validate="{ required: true }" name="name"
                        data-vv-as="姓名" :state="validateState('name')" trim aria-describedby="nameErr"></b-form-input>
                    <b-form-invalid-feedback id="nameErr">{{ veeErrors.first('name') }}</b-form-invalid-feedback>
                </b-form-group>

                <b-form-group label="性别:" label-align-lg="right" label-cols-lg="3" content-cols-lg="7"
                    content-align-lg="left" label-for="grade">
                    <b-form-radio-group id="grade" v-model="form.grade" :options="gradeOptions" name="grade"
                        v-validate="{ required: true }" data-vv-as="性别" :state="validateState('grade')"
                        aria-describedby="gradeErr" style="padding-top: 7px;"></b-form-radio-group>
                    <b-form-invalid-feedback id="gradeErr">{{ veeErrors.first('grade') }}</b-form-invalid-feedback>
                </b-form-group>

                <b-form-group label="手机号码:" label-align-lg="right" label-cols-lg="3" content-cols-lg="7"
                    label-for="phone">
                    <b-form-input id="phone" v-model="form.phone" trim v-validate="{ required: true, regex: '\\d{11}' }"
                        name="phone" data-vv-as="手机号码" :state="validateState('phone')"
                        aria-describedby="phoneErr"></b-form-input>
                    <b-form-invalid-feedback id="phoneErr">{{ veeErrors.first('phone') }}</b-form-invalid-feedback>
                </b-form-group>

                <b-form-group label="邮箱地址:" label-align-lg="right" label-cols-lg="3" content-cols-lg="7"
                    label-for="email">
                    <b-form-input id="email" v-model="form.email" trim v-validate="{ required: true, email: true }"
                        name="email" data-vv-as="邮箱地址" :state="validateState('email')"
                        aria-describedby="emailErr"></b-form-input>
                    <b-form-invalid-feedback id="emailErr">{{ veeErrors.first('email') }}</b-form-invalid-feedback>
                </b-form-group>

                <b-form-group label="出生年月:" label-align-lg="right" label-cols-lg="3" content-cols-lg="7"
                    label-for="birthDate">
                    <YearSelect v-model="birthDateYear" style="width:100px" v-validate="{ required: true }"
                        id="birthDateYear" name="birthDateYear" data-vv-as="出生年份"
                        :state="validateState('birthDateYear')">
                    </YearSelect>

                    <MonthSelect v-model="birthDateMonth" style="margin-left: 20px; width:100px"
                        v-validate="{ required: true }" id="birthDateMonth" name="birthDateMonth" data-vv-as="出生月份"
                        :state="validateState('birthDateMonth')"></MonthSelect>
                </b-form-group>


                <b-form-group label="参加工作年月:" label-align-lg="right" label-cols-lg="3" content-cols-lg="7"
                    label-for="workDate">
                    <YearSelect v-model="workDateYear" style="width:100px" v-validate="{ required: true }"
                        id="workDateYear" name="workDateYear" data-vv-as="出生年份" :state="validateState('workDateYear')"
                        aria-describedby="workDateYearErr"></YearSelect>
                    <MonthSelect v-model="workDateMonth" style="margin-left: 20px; width:100px"
                        v-validate="{ required: true }" id="workDateMonth" name="workDateMonth" data-vv-as="出生年份"
                        :state="validateState('workDateMonth')" aria-describedby="workDateMonthErr"></MonthSelect>
                </b-form-group>

                <b-form-group label="当前职称:" label-align-lg="right" label-cols-lg="3" content-cols-lg="7"
                    label-for="currentPosition">
                    <b-form-select v-model="form.currentPosition" :options="currentPositionOptions" style="width:220px"
                        v-validate="{ required: true }" id="currentPosition" name="currentPosition" data-vv-as="当前职称"
                        :state="validateState('currentPosition')" aria-describedby="currentPositionErr"></b-form-select>
                </b-form-group>

                <b-form-group label="当前工作单位:" label-align-lg="right" label-cols-lg="3" content-cols-lg="7"
                    label-for="currentUnit">
                    <b-form-input v-model="form.currentUnit" trim v-validate="{ required: true }" id="currentUnit"
                        name="currentUnit" data-vv-as="当前工作单位" :state="validateState('currentUnit')"
                        aria-describedby="currentUnitErr"></b-form-input>
                    <b-form-invalid-feedback id="currentUnitErr">{{ veeErrors.first('currentUnit')
                        }}</b-form-invalid-feedback>
                </b-form-group>

                <b-form-group label="研究方向:" label-align-lg="right" label-cols-lg="3" content-cols-lg="7"
                    label-for="researchDirection">
                    <vue-editor v-model="form.researchDirection" :editor-toolbar="customToolbar"></vue-editor>
                    <div v-if="isResearchDirectionError" class="invalid">研究方向必须填写</div>
                </b-form-group>

                <b-form-group label="已有航次经历（若无则写无）:" label-align-lg="right" label-cols-lg="3" content-cols-lg="7"
                    label-for="voyageExperience">
                    <vue-editor v-model="form.voyageExperience" :editor-toolbar="customToolbar"></vue-editor>
                    <div v-if="isVoyageExperienceError" class="invalid">已有航次经历必须填写</div>
                </b-form-group>

                <b-form-group label="列举在研究区域您感兴趣的科学问题及样品类型与设备需求:" label-align-lg="right" label-cols-lg="3"
                    content-cols-lg="7" label-for="researchNeeds">
                    <vue-editor v-model="form.researchNeeds" :editor-toolbar="customToolbar"></vue-editor>
                    <div v-if="isResearchNeedsError" class="invalid">科学问题及样品类型与设备需求必须填写</div>
                </b-form-group>

                <b-form-group label="个人简历:" label-align-lg="right" label-cols-lg="3" content-cols-lg="7"
                    label-for="attachment">
                    <b-form-file id="personalResumePath" placeholder="点击上传个人简历" accept=".pdf" @change="onFileChange"
                        :state="!isAttachmentError" name="attachment" data-vv-as="个人简历" trim
                        browse-text="上传Pdf文件"></b-form-file>
                    <div v-if="isAttachmentError" class="invalid">个人简历必须选择，并且只能是Pdf格式</div>

                    <!-- 已有附件 -->
                    <div v-if="isSubmited && form.personalResumeFileName" style="margin-top:10px;">
                        <b-alert show>已上传附件： {{ form.personalResumeFileName }}</b-alert>
                    </div>
                </b-form-group>

                <b-row style="margin-bottom: 10px;">
                    <b-col lg="5" sm="3" md="3">

                    </b-col>
                    <b-col>
                        <b-button type="submit" style="width: 160px; " variant="primary">
                            {{ isSubmited ? "重新提交" : "提交" }}</b-button>
                        <b-button v-if="isSubmited" type="button" style="width: 160px; margin-left: 20px;"
                            variant="danger" @click="delConfirmModal = true">
                            撤销</b-button>
                    </b-col>
                </b-row>

            </b-form>
        </div>

        <b-modal title="撤销申请确认" v-model="delConfirmModal" @ok="deleteData" ok-variant="danger"
            header-bg-variant="danger">

            <template v-slot:modal-ok>
                确认
            </template>

            <template v-slot:modal-cancel>
                取消
            </template>

            <b-alert variant="danger" show>撤销后不可以恢复，确定要撤销申请吗?</b-alert>
        </b-modal>

    </b-container>
</template>

<script>
import Vue from 'vue';
import { checkLogin } from '../../components/Checker'
import YearSelect from '../../components/YearSelect'
import MonthSelect from '../../components/MonthSelect'
import { VueEditor } from "vue2-editor";
import { axiosServer } from '@/api/judge';
import axios from '@/api/axios';
import { requestSvpChiefTraining } from '@/api/SvpConfig';

export default {
    name: 'svpChiefTraining',
    components: {
        YearSelect,
        MonthSelect,
        VueEditor
    },
    computed: {
        isResearchDirectionError() {
            return this.form.researchDirection == "";
        },
        isVoyageExperienceError() {
            return this.form.voyageExperience == "";
        },
        isResearchNeedsError() {
            return this.form.researchNeeds == "";
        },
        isAttachmentError() {
            return this.form.personalResumeFileName == null
        }
    },
    data() {
        return {
            delConfirmModal: false,
            uploadFile: null,
            isSubmited: false, // 是否在编辑
            // 编辑器
            customToolbar: [
                ["bold", "italic", "underline"],
                [{ list: "ordered" }, { list: "bullet" }],
                ["clean"]
            ],
            // 表单
            birthDateYear: '',
            birthDateMonth: '',
            workDateYear: '',
            workDateMonth: '',
            currentPositionOptions: [
                { value: '1', text: '教授' },
                { value: '2', text: '副教授' },
                { value: '3', text: '助教' },
                { value: '4', text: '研究员' },
                { value: '5', text: '助理研究员' },
                { value: '6', text: '教授级高工' },
                { value: '7', text: '高级工程师' },
                { value: '8', text: '工程师' },
                { value: '9', text: '助理工程师' },
                { value: '10', text: '其它' }
            ],
            form: {
                name: '',
                grade: '',
                phone: '',
                email: '',
                birthDate: '',
                workDate: '',
                currentPosition: '',
                currentUnit: '',
                researchDirection: '',
                voyageExperience: '',
                researchNeeds: '',
                personalResumePath: '',
                personalResumeFileName: null
            },
            attachment: null,
            gradeOptions: [
                { value: '0', text: '男' },
                { value: '1', text: '女' }
            ],
            promptMsg: null,
            expired: false
        };
    },
    activated() {
        checkLogin(this, "请先登录", 'svpChiefTraining')
        this.getSelfData();
        this.getSvpCOnfig();
    },
    mounted() {

    },
    methods: {
        getSvpCOnfig() {
            requestSvpChiefTraining().then(resp => {
                this.promptMsg = resp.content;
                this.expired = resp.expired;
            });
        },
        alert(msg) {
            alert(msg)
        },
        validateState(ref) {
            if (
                this.veeFields[ref] &&
                (this.veeFields[ref].dirty || this.veeFields[ref].validated)
            ) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },
        onFileChange(e) {
            const file = e.target.files[0];
            const fileName = file.name;

            // 如果后缀名不为pdf, 则提示错误
            if (!fileName.toLowerCase().endsWith('.pdf')) {
                this.attachment = null;
                this.form.personalResumeFileName = null;
                return;
            }

            this.isSubmited = false;
            this.attachment = file;
            this.form.personalResumeFileName = fileName;
        },
        // 查询数据
        getSelfData() {
            axiosServer({
                url: "/svpChiefTrainingVoyage/getSelfData",
                type: 'get'
            })
                .then(resp => {
                    const data = resp.data.data
                    if (data && data.id > 0) {
                        this.form = data
                        this.isSubmited = true

                        const birthDateArr = data.birthDate.split('-')
                        this.birthDateYear = birthDateArr[0]
                        this.birthDateMonth = birthDateArr[1]

                        const workDateArr = data.workDate.split('-')
                        this.workDateYear = workDateArr[0]
                        this.workDateMonth = workDateArr[1]
                    } else {
                        // 没有数据则重置
                        this.form = {
                            name: '',
                            grade: '',
                            phone: '',
                            email: '',
                            birthDate: '',
                            workDate: '',
                            currentPosition: '',
                            currentUnit: '',
                            researchDirection: '',
                            voyageExperience: '',
                            researchNeeds: '',
                            personalResumePath: '',
                            personalResumeFileName: null
                        }

                        this.isSubmited = false
                    }
                })
                .catch(e => {
                    this.alert(e)
                });
        },
        // 提交
        onSubmit() {
            const _this = this

            let isValid = true;

            if (this.isResearchDirectionError) {
                this.isResearchDirectionError = true;
                isValid = false
            }

            if (this.isVoyageExperienceError) {
                this.isVoyageExperienceError = true;
                isValid = false
            }

            if (this.isResearchNeedsError) {
                this.isResearchNeedsError = true;
                isValid = false
            }

            if (this.isSubmited == false) {
                if (this.attachment == null) {
                    this.isAttachmentError = true;
                    isValid = false;
                }
            }

            this.$validator.validateAll().then(result => {

                if (!result || !isValid) {
                    return;
                }

                // 组合属性
                this.form.birthDate = this.birthDateYear + '-' + this.birthDateMonth;
                this.form.workDate = this.workDateYear + '-' + this.workDateMonth;

                if (this.form.personalResumeFileName === null) {
                    this.alert("个人简历必须选择，并且只能是Pdf格式");
                    return
                }

                // 上传数据
                axiosServer({
                    url: "/svpChiefTrainingVoyage/submitData",
                    type: 'post',
                    params: this.form
                })
                    .then(resp => {
                        if (resp.data.code == 0) {
                            // 上传文件
                            let param = new FormData(); // 创建form对象
                            param.append('fileName', this.attachment); // 通过append向form

                            const apiUrl = "/svpChiefTrainingVoyage/submitFile";
                            const url = process.env.NODE_ENV == 'development' ? '/proxyApi' + apiUrl : apiUrl;

                            axios.post(
                                url,
                                param,
                                {
                                    headers: {
                                        'Content-Type': 'multipart/form-data'
                                    }
                                }
                            )
                                .then(resp => {
                                    if (resp.data.code == 0) {
                                        _this.getSelfData()
                                        // 提示成功
                                        alert("提交成功")
                                    } else {
                                        alert("提交失败:" + resp.data.msg)
                                    }
                                })
                                .catch(e => {
                                    alert("提交失败")
                                });
                        }
                    })
                    .catch(e => {
                        alert(e)
                    });

            });
        },
        // 删除
        deleteData() {
            // 发送撤销申请
            axiosServer({
                url: "/svpChiefTrainingVoyage/Delete",
                type: 'delete',
                params: {}
            }).then(resp => {
                if (resp.data.code == 0) {
                    this.delConfirmModal = false
                    this.getSelfData()

                    alert("撤销成功")
                } else {
                    alert("撤销失败:" + resp.data.msg)
                }
            }).catch(e => {
                alert(e)
            });
        }
    }
}
</script>

<style scoped>
.invalid {
    width: 100%;
    margin-top: .25rem;
    font-size: .875em;
    color: #dc3545;
}
</style>